import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Verify() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    console.log(code);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">
          A verification code has been sent to your email
        </h1>
        <form onSubmit={handleLogin}>
          <label>Enter Code</label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter your verification code"
            required
          />

          <button type="submit">Submit</button>
        </form>
        <p className="signup-text">
          Don't have an account?{" "}
          <span onClick={() => navigate("/signup1")}>Sign Up</span>
        </p>
      </div>
    </div>
  );
}
